/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Policy from 'shared/api/assurant/policy';
import { PolicyResponse } from 'shared/api/assurant/policy/types';
import { AxiosError } from 'axios';
import { ErrorDataDetails } from './types';


export const usePolicyMutationQuery = () => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: Policy.issue,
		onSuccess: data => {
			queryClient.setQueryData(['policyData'], data.data)
		},
		onError: (error: AxiosError<ErrorDataDetails>) => {
			queryClient.setQueryData(['errorDetails'], error.response?.data)
		}
	})
}
export const usePolicyQuery = () => {
	const client = useQueryClient()
	return client.getQueryData<PolicyResponse>(['policyData'])
}
export const usePolicyErrorQuery = () => {
	const client = useQueryClient()
	return client.getQueryData<any>(['errorDetails'])
}
